import { Html, Scroll, useScroll } from "@react-three/drei";
import { useCallback, useRef } from "react";
import gsap from "gsap";
import { useFrame, useThree } from "@react-three/fiber";


export default function ContentOne() {

  const ref = useRef()
  const scroll = useScroll()
  const { viewport } = useThree()

  const animateIntro = useCallback((node) => {
    if (!node) return;
    if (node.dataset.prepared) return;
    node.dataset.prepared = "true";

    const text = node.innerText;
    const lines = text.split("\n");
    node.innerHTML = "";
    lines.forEach((line, i) => {
      const lineSpan = document.createElement("span");
      for (const ch of line) {
        const s = document.createElement("span");
        s.textContent = ch === " " ? "\u00A0" : ch; // garde les espaces
        s.style.display = "inline-block";
        s.style.opacity = "0";
        s.style.transform = "translateY(5px)";
        lineSpan.appendChild(s);
      }
      node.appendChild(lineSpan);
      if (i < lines.length - 1) node.appendChild(document.createElement("br"));
    });

    const letters = node.querySelectorAll("span > span");
    gsap.to(letters, {
      opacity: 1,
      y: 0,
      stagger: 0.03,
      duration: 0.2,
      ease: "power2.out",
    });
  }, []);


  const animateParagraph = useCallback((node) => {
    if (!node) return;
    if (node.dataset.prepared) return; // évite double init
    node.dataset.prepared = "true";

    const text = node.innerText; // récupère avec \n pour les <br />
    const lines = text.split("\n");
    node.innerHTML = "";
    lines.forEach((line, i) => {
      const lineSpan = document.createElement("span");
      for (const ch of line) {
        const s = document.createElement("span");
        s.textContent = ch === " " ? "\u00A0" : ch; // garde les espaces visibles
        s.style.display = "inline-block";
        s.style.color = "#ffffff0f"; // état initial (comme ton style inline)
        lineSpan.appendChild(s);
      }
      node.appendChild(lineSpan);
      if (i < lines.length - 1) node.appendChild(document.createElement("br"));
    });

    const letters = node.querySelectorAll("span > span");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) {
            gsap.to(letters, {
              color: "white",
              stagger: 0.04,
              duration: 0.6,
              ease: "power2.out",
            });
            io.unobserve(node);
            io.disconnect();
          }
        });
      },
      { threshold: [0, 0.6, 1] }
    );

    io.observe(node);
  }, []);

  useFrame(() => {
    if (!ref.current) return
    const totalScroll = scroll.offset * scroll.pages * viewport.height
    const compensation = totalScroll * 0.1
    ref.current.style.transform = `translate3d(0, ${compensation}px, 0)`
    // console.log('compensation:', compensation, 'scroll.offset:', scroll.offset)
  })

  return (
    <Scroll>
      <Html fullscreen >
        <div
          className="container-content-one"
          ref={ref}
          style={{
            pointerEvents: "none",
            whiteSpace: "pre-wrap", // garde espaces + retours à la ligne
            willChange: 'transform'
          }}
        >
          {/* 1er paragraphe : apparition lettre + Y */}
          <p ref={animateIntro} style={{ color: "white" }}>
            Hi ! I am Robin, <br />
            french creative <br />
            developer and <br />
            looking for <br />
            opportunities
          </p>

          {/* Suivant : anim visibilité → blanc lettre par lettre */}
          <p ref={animateParagraph} style={{ color: "#ffffff0f" }}>
            Freelance <br />
            Or permanent job <br />
            Remote <br />
          </p>
          <p ref={animateParagraph} style={{ color: "#ffffff0f" }}>
            Scroll to continue
          </p>
        </div>
      </Html>
    </Scroll>
  );
}
